/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs */

const en_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`marketplaces`)
};

const ar_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسواق`)
};

const bn_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মার্কেটপ্লেস`)
};

const de_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplätze`)
};

const es_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces`)
};

const fr_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces`)
};

const pt_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces`)
};

const zh_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

const tr_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazar yerleri`)
};

const ru_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейсы`)
};

const pl_svc_ecommerce_amazon_tools_tlm_0 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace'y`)
};

/**
* | output |
* | --- |
* | "marketplaces" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_tlm_0 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_tlm_0(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_tlm_0(inputs)
	return en_svc_ecommerce_amazon_tools_tlm_0(inputs)
});
export { svc_ecommerce_amazon_tools_tlm_0 as "svc_ecommerce-amazon-tools_tlm_0" }